import { useQuasar } from 'quasar';

const DARK_MODE_LOCAL_STORAGE_KEY = 'DARK_MODE';
interface DarkMode {
  setDarkMode: (value: boolean) => boolean;
  getDarkMode: () => boolean;
  loadDarkModeFromStorage: () => void;
}

export const useDarkMode: () => DarkMode = () => {
  const $q = useQuasar();
  const setDarkMode = (value: boolean): boolean => {
    localStorage.setItem(DARK_MODE_LOCAL_STORAGE_KEY, JSON.stringify(value));
    $q.dark.set(value);
    return value;
  };
  const getDarkMode = (): boolean => {
    const value = localStorage.getItem(DARK_MODE_LOCAL_STORAGE_KEY);
    if (value) {
      return JSON.parse(value);
    } else {
      return true;
    }
  };

  const loadDarkModeFromStorage = (): void => {
    const value = getDarkMode();
    setDarkMode(value);
  };

  return { setDarkMode, getDarkMode, loadDarkModeFromStorage };
};
